export default "__VITE_ASSET__BlUgV6aV__"